import UserInitFailedPage from './UserInitFailedPage'
export default UserInitFailedPage
